import take from 'lodash/take'
import React, { FC } from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { ProductSlider } from '@Domains/Product/Features/ProductSlider/ProductSlider'
import { Product } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from '../Display.module.scss'

interface RelatedProductsProps {
  products: Product[]
  sourceID?: string
}

export const RelatedProducts: FC<RelatedProductsProps> = ({ products, sourceID }) => {
  const { t } = useTranslation()

  if (!products || products.length === 0) {
    return null
  }

  return (

    <BlockContainer
      appearance={{
        backgroundColor: 'var(--green-500)',
        textColor: 'var(--white)',
      }}
      className={styles.productSliderWrapper}
      common={{
        position: 'left',
        title: t('products:WB_RELATED_PRODUCTS_LABEL'),
        titleElement: 'h2',
        text: {
          key: 'cms:SIMILAR_PRODUCTS_LABEL',
          value: {
            children: [
              {
                children: [
                  {
                    text: t('products:PRODUCT_RECOMMENDATION_FREQUENTLY_BOUGHT_TOGETHER_LABEL', 'Frequently bought together'),
                  },
                ],
                type: 'p',
              },
            ],
          },
        },
      }}
    >
      <ProductSlider
        className={styles.productSlider}
        products={take(products, 18)}
        sourceID={sourceID}
      />
    </BlockContainer>
  )
}

